import React from 'react';
import {local} from '../../../Context/Local';
import { useHistory } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
// import FavoriteIcon from '@material-ui/icons/Favorite';

// cuG
import {useStyleC} from '../st/UseStyle';
// csG
import {style} from '../st/cStyle'

import Icons from './Icons';
import {useTranslation} from 'react-i18next';


export default function CardP() {
  const {t} = useTranslation();
  const classes = useStyleC();
  const [expanded] = React.useState(false);
  let his = useHistory();

  const dept = (i) => {
    his.push({
      pathname: '/depts',
      state: { local:local[i], },
    })
  };

  return (
    <Card className={classes.rootCust}>
      {/* <CardHeader className={classes.header}
        avatar={
          <Avatar  aria-label="recipe" className={classes.avatar}>
            1
          </Avatar>
        }
        // action={
        //   <IconButton aria-label="settings">
        //     <MoreVertIcon />
        //   </IconButton>
        // }
        // title=""
        subheader=""
      /> */}
      <CardActionArea onClick={()=>dept(3)}>
      <CardMedia className={classes.mediaP} />

      <CardContent className={classes.content} style={style.color.customer}>
        <Typography variant="h5">
       {t('customers-and-suppliers-title')}
        </Typography>
      </CardContent>
      </CardActionArea>
      <CardActions disableSpacing className={classes.actions}>
        {/* <IconButton aria-label="add to favorites"> <FavoriteIcon /> </IconButton> */}
        {/* <IconButton aria-label="share"> <ShareIcon /></IconButton> */}
        {/* <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton> */}
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className={classes.slidcontent}>
          {/* <Typography > */}
            {/*  */}
          {/* </Typography> */}

          {/* <Typography > */}
          <Icons/> 
          {/* </Typography> */}



       
        </CardContent>
      </Collapse>
    </Card>
  );
}

